import {
    Component,
    effect,
    EventEmitter,
    Input,
    OnInit,
    Output,
    signal,
    TemplateRef,
    WritableSignal
} from '@angular/core';
import {TramiteRequisitosRqInterface} from "../../../../users/tramites/components/interfaces/tramites.interface";
import {TramiteService} from "../../../../users/tramites/services/tramite.service";
import {TramiteStatsInterface} from "../../../interfaces/tramites-estadisticas";
import {ListboxModule} from "primeng/listbox";
import {FormsModule} from "@angular/forms";
import {PrimeNgModule} from "../../../prime-ng/prime-ng.module";
import { Router } from '@angular/router';

@Component({
    selector: 'app-info-dialog-requisitos',
    standalone: true,
    imports: [
        ListboxModule,
        FormsModule,
        PrimeNgModule
    ],
    templateUrl: './info-dialog-requisitos.component.html',
    styleUrl: './info-dialog-requisitos.component.scss'
})
export class InfoDialogRequisitosComponent implements OnInit {
    @Input() public visible: boolean = false;
    @Input() public tramiteStats!: TramiteStatsInterface;
    @Input() datosCargados!: boolean;
    @Input() loading!: TemplateRef<any>;
    @Output() closeDialogEvent = new EventEmitter<void>();
    selectedRequisito!: TramiteRequisitosRqInterface
    _requisitosInfo: WritableSignal<TramiteStatsInterface> = signal({
        idTramite: 0, idSolicitud: 0, idProyecto: 0, nombreTramite: ''
        , stats: {qtycumplidos: 0, qtyrequeridos: 0}, requisitos: [] = []
    });

    constructor(protected tramite: TramiteService, private router: Router) {
    }

    ngOnInit(): void {
        this.mostrarInfoRequisitos();

    }

    /**Este metodo muestra la cantidad de requisitos del proyecto en su expediente*/
    mostrarInfoRequisitos() {
        this.tramite.getRequisitosPorParametros(String(this.tramiteStats.idTramite!), String(this.tramiteStats.idProyecto!), null);
    }

    closeDialog() {
        this.closeDialogEvent.emit();
        this.tramite.datosCargados = false;
        this.cleanRequisitosInfo()
    }

    cleanRequisitosInfo() {
        this._requisitosInfo.set({
            idTramite: 0, idSolicitud: 0, idProyecto: 0, nombreTramite: ''
            , stats: {qtycumplidos: 0, qtyrequeridos: 0}, requisitos: [] = []
        });
    }

    requisitosInfoEffect = effect(() => {
        let requisitos = this.tramite._requisitosFormularios();
        if (requisitos.length > 0) {
            this._requisitosInfo.update(data => ({
                ...data,
                requisitos
            }));
        } else {
            this.cleanRequisitosInfo();
        }
    }, {allowSignalWrites: true});

    completarPagos() {
        const id = this.tramite.idProyecto() ? this.tramite.idProyecto() : '';
        this.router.navigate(['/users/pagos/tramites', id]);
    }

}
